import { render } from "./fileUpload.vue?vue&type=template&id=5fe87222&scoped=true&ts=true"
import script from "./fileUpload.vue?vue&type=script&lang=ts"
export * from "./fileUpload.vue?vue&type=script&lang=ts"

import "./fileUpload.vue?vue&type=style&index=0&id=5fe87222&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe87222"]])

export default __exports__